import { createReducer, on } from '@ngrx/store';
import {
  setEnumsAction,
  setInputTypeMappingAction,
  setMenuListAction,
} from './system.actions';
import { initialSystemState, SystemState } from './system.state';

export const systemReducer = createReducer(
  initialSystemState,
  on(
    setEnumsAction,
    (state, { enums }): SystemState => ({
      ...state,
      enums: enums,
    })
  ),
  on(
    setInputTypeMappingAction,
    (state, { inputTypeMapping }): SystemState => ({
      ...state,
      inputTypeMapping: inputTypeMapping,
    })
  ),
  on(
    setMenuListAction,
    (state, { menuList, loaded }): SystemState => ({
      ...state,
      menuList: menuList,
      menuListLoaded: loaded,
    })
  )
);
